export const APP_PATH = {
  ROOT: '/',
  // CPMS BO PATHS /////////////////////////////////////////////////////////////
  DASHBOARD: '/',
  MUST_RESET_PASSWORD: '/must-reset-password',
  LOGIN: '/login',
  PROFILE: '/profile',
  SETTINGS: '/settings',
  STATISTICS: '/statistics',
  ROLE: {
    LIST: '/roles',
    DETAILS: '/roles/:id',
  },
  CUSTOMER: {
    LIST: '/customer',
    DETAILS: '/customer/:id',
  },
  CHANNEL: {
    LIST: '/channels',
  },
  CHARGE_POINT: {
    LIST: '/charge-points',
    DETAILS: '/charge-points/:id',
  },
  INVOICE: {
    LIST: '/invoices',
    DETAILS: '/invoices/:id',
  },
  LOCATION: {
    LIST: '/locations',
    DETAILS: '/locations/:id',
  },
  NETWORK: {
    LIST: '/networks',
    DETAILS: '/networks/:id',
  },
  TRANSACTION: {
    LIST: '/transactions',
    DETAILS: '/transactions/:id',
  },
  TARIFF: {
    LIST: '/tariffs',
    DETAILS: '/tariffs/:id',
  },
  TICKET: {
    LIST: '/tickets',
    DETAILS: '/tickets/:id',
  },
  USER: {
    LIST: '/user',
    DETAILS: '/user/:id',
  },
  TOKEN: {
    LIST: '/tokens',
    DETAILS: '/tokens/:id',
  },
  // EMSP BO PATHS /////////////////////////////////////////////////////////////
  EMSP_BO_CHARGING_SESSION: {
    LIST: '/emsp-bo-charging-sessions',
    DETAILS: '/emsp-bo-charging-sessions/:id',
  },
  EMSP_BO_EMSP_USER: {
    LIST: '/emsp-bo-emsp-users',
    DETAILS: '/emsp-bo-emsp-users/:id',
  },
  EMSP_BO_INVOICE: {
    LIST: '/emsp-bo-invoices',
    DETAILS: '/emsp-bo-invoices/:id',
  },
  EMSP_BO_EMSP_LOCATION: {
    LIST: '/emsp-bo-locations',
    DETAILS: '/emsp-bo-locations/:id',
  },
  EMSP_BO_RFID_BADGE_ORDER: {
    LIST: '/emsp-bo-rfid-badge-orders',
    DETAILS: '/emsp-bo-rfid-badge-orders/:id',
  },
  EMSP_BO_TARIFF: {
    LIST: '/emsp-bo-tariffs',
    DETAILS: '/emsp-bo-tariffs/:id',
  },
};
